<template>
  <Marks />
</template>

<script>
import Marks from '@/views/administration/management/marks/components/marks'

export default {
  name: 'Index',
  components: { Marks },
}
</script>

<style scoped>

</style>
